module.exports = __webpack_public_path__ + "static/media/4.b76863d6.png";